import request from '@/utils/request'

// 获取芯片列表
export function getChipList(params) {
  return request({
    url: '/admin/chips',
    method: 'get',
    params
  })
}

// 获取芯片详情
export function getChipDetail(id) {
  return request({
    url: `/admin/chips/${id}`,
    method: 'get'
  })
}

// 获取芯片关联的机器人列表
export function getChipRobots(id) {
  return request({
    url: `/admin/chips/${id}/robots`,
    method: 'get'
  })
}

// 创建芯片
export function createChip(data) {
  return request({
    url: '/admin/chips',
    method: 'post',
    data
  })
}

// 更新芯片
export function updateChip(id, data) {
  return request({
    url: `/admin/chips/${id}`,
    method: 'put',
    data
  })
}

// 删除芯片
export function deleteChip(id) {
  return request({
    url: `/admin/chips/${id}`,
    method: 'delete'
  })
}

// 批量删除芯片
export function batchDeleteChips(ids) {
  return request({
    url: '/admin/chips/batch',
    method: 'delete',
    data: { ids }
  })
}

